<template>
<div class="bg-white px-8 py-4 ">
    <div class="mb-4">
        <div class="heading flex flex-row items-center justify-between py-2 px-8">
            <div>
                <div class="page text-white">Add Exercise</div>
            </div>
            <div>
                <img class="h-20" :src="require('../../../assets/quiz_image.png')" alt="" />
            </div>
        </div>
    </div>
    <div class="flex flex-wrap my-8">
        <div class="w-full md:w-1/2">
            <div class="flex flex-row flex-wrap items-center form-row mb-8 px-2">
                <div class="modal-field font-semibold">Exercise Title:</div>
                <div class="w-full sm:w-2/3 ml-auto">
                    <linput type="text" name="fname" v-model="form.title" :errorMessage="errors.title" :error="errors.title" placeholder="Title of Exercise" />
                </div>
            </div>
        </div>

        <div class="w-full md:w-1/2">
            <div class="flex flex-row flex-wrap items-center form-row mb-8 px-2">
                <div class="modal-field font-semibold">Exercise Score:</div>
                <div class="w-full sm:w-2/3 ml-auto">
                    <linput type="text" name="fname" v-model="form.score" :errorMessage="errors.score" :error="errors.score" placeholder="Score of Exercise" />
                </div>
            </div>
        </div>

        <div class="w-full my-4">
            <div class="modal-field font-semibold main-tenant-color">
                Requirements:
            </div>
            <ltextarea v-model="form.requirements" placeholder="Enter requirements here" />
        </div>

        <div class="w-full my-4">
            <div class="modal-field font-semibold main-tenant-color">
                Enable Questions Story
            </div>
            <div class="my-2">
                <switches color="green" v-model="showStory">
                </switches>
                <span class="ml-4 mb-2 pb-2 font-bold">{{
                  showStory ? "Yes" : "No"
                  }}</span>
            </div>
            <vue-editor v-if="form.questions.length > 0 && showStory" id="editor" useCustomImageHandler v-model="form.questions[0].story"> </vue-editor>
            <!--            <ltextarea v-if="form.questions.length > 0 && showStory" v-model="form.questions[0].story" placeholder="Enter  Story" />-->
        </div>

        <div class="w-full flex flex-wrap" v-for="(question, index) in form.questions" :key="index">
            <div class="flex w-full flex-wrap justify-between">
                <page-header class="py-2 uppercase main-tenant-color ">Question {{ index + 1 }}
                </page-header>

            </div>
            <div class="my-4 w-full md:w-1/2">

                <main class="mx-2">

                    <vue-editor v-model="form.questions[index].question" :id="`editor${index}`" useCustomImageHandler> </vue-editor>

                    <!--<ltextarea v-model="form.questions[index].question" placeholder="Enter Question" />-->

                    <p>Activate Auto Grading </p>

                    <div class="my-2">
                        <switches color="green" v-model="labels[index].showLabel">
                        </switches>
                        <span class="ml-4 mb-2 pb-2 font-bold">{{
                    labels[index].showLabel ? "Yes" : "No"
                  }}</span>
                    </div>
                    <div class="w-full sm:w-2/3  mt-3">
                        <lselect v-if="labels[index].showLabel" v-model="form.questions[index].label_id" :items="fetchAllLabels" placeholder="Select Label" />
                    </div>

                </main>
            </div>
            <div class="flex flex-wrap justify-between">
                <p v-if="index > 0" @click="deleteQuestion(index)" class="mx-2 cursor-pointer text-red-500">
                    Remove Question
                </p>
            </div>
        </div>
    </div>

    <div class="flex flex-col justify-center items-center">
        <div class="mb-2">
            <lms-button @click="addQuestion">Add Question</lms-button>
        </div>
    </div>

    <div class="flex flex-col justify-center items-center">
        <div class="mb-2">
            <lms-button @click="handleFormSubmit">Create Exercise</lms-button>
        </div>
    </div>
</div>
</template>

<script>
import {
    mapActions,
    mapGetters,
    mapMutations
} from "vuex";
import FormActions from "@/mixins/FormActions";
import Switches from "vue-switches";
import {
    VueEditor
} from "vue2-editor";

export default {
    mixins: [FormActions],
    data() {
        return {
            id: "",
            errors: [],
            form: {
                questions: [{
                    question: "",
                }, ],
            },
            showStory: false,
            labels: [{
                showLabel: false
            }]
        };
    },
    computed: {
        ...mapGetters(["getTenantPrograms", "fetchTenantLabels"]),
        getPrograms() {
            let programs = this.getTenantPrograms;
            let sortedPrograms = [];
            for (let i = 0; i < programs.length; i++) {
                let temp = {
                    text: programs[i].title,
                    value: programs[i].id,
                };
                sortedPrograms = sortedPrograms.concat(temp);
            }
            return sortedPrograms;
        },
        fetchAllLabels() {
            let labels = this.fetchTenantLabels;
            console.log(labels)
            if (!labels) return [];
            let data = [];
            labels.forEach((label) => {
                let obj = {};
                obj.text = label.label_text;
                obj.value = label.id;
                data.push(obj);
            });
            return data;
        },
    },
    components: {
        linput: () => import("@/components/general/input"),
        ltextarea: () => import("@/components/general/textarea"),
        LmsButton: () => import("@/components/general/button"),
        lselect: () => import("@/components/forms/select"),
        PageHeader: () => import("@/components/general/pageheader"),
        Switches,
        VueEditor
    },
    methods: {
        ...mapMutations(["updateLoader"]),
        ...mapActions(["tenantCreateExercise", "fetchLabels"]),

        addQuestion() {
            let question = {
                question: "",
            };

            this.form.questions.push(question);
            let new_label = {
                showLabel: false,
            }
            this.labels.push(new_label);
        },
        deleteQuestion(index) {
            this.form.questions.splice(index, 1);
            this.labels.splice(index, 1);
        },
        async handleFormSubmit() {
            this.errors = [];
            this.updateLoader(true);
            let res = await this.tenantCreateExercise(this.form);
            this.updateLoader(false);
            if (res == true || res.status == 200 || res.status == 201) {
                this.$Bus.$emit("notify", {
                    type: "success",
                    message: "Exercise created successfully",
                });
                this.$router.replace({
                    name: "tenant-resources"
                });
            } else {
                this.errors = res.data.errors[0].source;
                this.$Bus.$emit("notify", {
                    type: "error",
                    message: res.data.errors ?
                        res.data.errors[0].title : "An error occured",
                });
            }
        },
    },
    async mounted() {
        await this.fetchLabels({
            type: 'exercise'
        })
    }

};
</script>

<style lang="scss" scoped>
@import "~vue2-editor/dist/vue2-editor.css";

/* Import the Quill styles you want */
@import '~quill/dist/quill.core.css';
@import '~quill/dist/quill.bubble.css';
@import '~quill/dist/quill.snow.css';

.form-row {
    width: 100%;
}

.modal {
    z-index: 10;

    .overlay {
        background: #b1b3b9;
        opacity: 0.89;
        z-index: 0;
    }

    .modal-content {
        width: 100%;
        width: 1001px !important;

        .modal-title {
            font-size: 24px;
            color: color(lms-tenant);
        }

        .modal-field {
            color: color(lms-tenant);
            max-width: calc(135px + 16px);
            width: 100%;
        }

        .close {
            background-color: #c2454b;
            height: 30px;
            width: 30px;
            border-radius: 50%;
            font-size: 12px;
            top: -17px;
            z-index: 2;
            right: -16px;
        }

        z-index: 1;
    }
}
</style>
